import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { Category, CategoryService } from '../../categories/shared';
import { Filter, FilterFilterPipe } from '../shared';

@Component({
  selector: 'filter-filter-bar',
  templateUrl: './filter-filter-bar.component.html',
  styleUrls: ['./filter-filter-bar.component.scss'],
  providers: [CategoryService, FilterFilterPipe]
})
export class FilterFilterBarComponent implements OnInit {
  @Input() items: Array<Filter> = [];
  @Input() itemsFiltered: Array<Filter> = [];
  @Input() reorder: boolean = false;
  @Output() itemsFilteredChange: EventEmitter<any> = new EventEmitter();
  @Output() reorderChange: EventEmitter<any> = new EventEmitter();

  private categories: Array<Category>;
  private name: string;
  private category: String;

  constructor(
    private categoryService: CategoryService,
    private filterFilterPipe: FilterFilterPipe
  ) {}

  ngOnInit() {
    this.loadFilters();
    this.categoryService
      .getAll()
      .subscribe(categories => {
        this.categories = categories;

        if (Array.isArray(this.items)) {
          this.filterItems();
        }
      })
    ;
  }

  changeMode() {
    this.name = '';
    this.category = (this.reorder === false) ? null : this.categories[0]._id;
    this.filterItems();
    this.reorderChange.emit(this.reorder);
  }

  private filterItems() {
    this.itemsFiltered = this.filterFilterPipe
      .transform(this.items, this.name, this.category)
    ;

    this.itemsFiltered.sort((a: Filter, b: Filter) => a.position - b.position);
    this.itemsFilteredChange.emit(this.itemsFiltered);

    this.saveFilters();
  }

  loadFilters() {
    const filters: any = JSON.parse(localStorage.getItem('filterListFilters'));

    if (filters && Object.keys(filters).length) {
      this.name = filters.name;
      this.category = filters.category;
    }

    console.log('load', filters);
  }

  saveFilters() {
    const data: any = {
      name: this.name,
      category: this.category
    };

    console.log('save', data);

    localStorage.setItem('filterListFilters', JSON.stringify(data));
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/filters/filter-filter-bar/filter-filter-bar.component.ts